import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  let intPartFormat = 0
  if(typeof value == "string"){
    intPartFormat = value.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$&,')//浮点数
  }else{
    if(value % 1 === 0){
      intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
    }else{
      intPartFormat = value.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$&,')//浮点数
    }
  }
  return intPartFormat
})

Vue.filter('formatNumber', function (value) {
  if (!value) {
    return '0'
  }
  let intPartFormat = 0
  if(typeof value == "string"){
    intPartFormat = value.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$&,')//浮点数
  }else{
    value = value.toFixed(2)
    if(value % 1 === 0){
      intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
    }else{
      intPartFormat = value.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$&,')//浮点数
    }
  }
  return intPartFormat
})

Vue.filter('dayjs', function (dataStr, pattern = 'YYYY-MM-DD') {
  if(dataStr == '~'){
    return dataStr
  }
  return moment(dataStr).format(pattern)
})

Vue.filter('getDays',function(dataStr,pattern = 'YYYY-MM-DD'){
  if(dataStr == "~"){
    return dataStr;
  }
  let today = moment(new Date()).format(pattern)
  let newTime = moment(dataStr).format(pattern)
  return moment(today).diff(moment(newTime),'day')
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  if(dataStr == '~'){
    return '~'
  }
  return moment(dataStr).format(pattern)
})

Vue.prototype.$moment = moment